import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IUserData } from '../../../types/interfaces';
import * as actions from '../../../redux/actions/user';

import Clock from '../../../assets/images/Clock.svg';
import style from './Header.module.scss';

interface IProps {
  ownerData: IUserData;
  setAuthLogout: any;
  setUserDataLogout: any;
}

const Header: React.FC<IProps> = ({
  ownerData: { userFirstName, userLastName, userMiddleName, companyName },
  setAuthLogout,
  setUserDataLogout,
}: IProps) => {
  const [time, setTime] = useState('');

  const setDate = () => {
    const date = new Date(Date.now());
    const minutes = date.getMinutes() >= 10 ? date.getMinutes() : `0${date.getMinutes()}`;
    const hours = date.getHours() >= 10 ? date.getHours() : `0${date.getHours()}`;
    setTime(`${hours}:${minutes}`);
  };

  useEffect(() => {
    setDate();
    const tick = setInterval(setDate, 10000);

    return () => {
      clearInterval(tick);
    };
  });

  const logout = async () => {
    await fetch('/api/auth/logout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
    })
      .then((response) => response.json())
      .then(({ sectionUrl }) => {
        (async () => {
          await localStorage.clear();
          await setUserDataLogout({} as IUserData);
          await setAuthLogout(false);
          window.location.assign(`${sectionUrl}`);
        })();
      });
  };

  return (
    <header className={style.header}>
      <div className={style.time}>
        <img src={Clock} alt="Clock" className={style.clock} />
        <div>
          <p className={style.currentTime}>{time} GMT+3</p>
          <p className={style.description}>Время в системе</p>
        </div>
      </div>
      <div className={style.logout}>
        <div className={style.company}>
          <p className={style.companyOwner}>{`${userLastName || ''}
           ${(userFirstName && [userFirstName?.[0], '.'].join('')) || ''}
           ${(userMiddleName && [userMiddleName?.[0], '.'].join('')) || ''}`}</p>
          <p className={style.companyDescription}>{companyName}</p>
        </div>
        <button type="button" aria-label="Выход" className={style.btn} onClick={logout} />
      </div>
    </header>
  );
};

// const mapStateToProps = (state: IState) => {};

export default connect(null, actions)(Header);
